import React, { useEffect, useRef } from "react";
import HeaderList from "../../../components/HeaderList";
import { Button, DatePicker, Image, Spin, Table, Tag } from "antd";
import moment from "moment";
import { getColumnSearchProps } from "../../../utils/tables";
import styles from "../styles/DriversPauseHistoryUI.module.css";
const DriversPauseHistoryUI = (props) => {
  const { loading, pausesHistory, dates, onChangeDates, exportToCSV } = props;
  const viewRef = useRef();

  const columns = [
    {
      title: "Fecha y Hora",
      dataIndex: "requestedAt",
      align: "center",
      render: (date) => moment(date).format("DD/MM/YYYY HH:mm A"),
      sorter:((a,b)=> moment(a.requestedAt).unix() - moment(b.requestedAt).unix())
    },
    {
      title: "Nombre del Driver",
      dataIndex: "driverName",
      ...getColumnSearchProps("driverName"),
    },
    {
      title: "Motivo",
      align: "center",
      dataIndex: "reasonName",
      filters: [
        {
          text: "Desperfecto Mecánico",
          value: "1",
        },
        {
          text: "Otros",
          value: "2",
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.reason === value,
    },
    {
      title: "Foto",
      align: "center",
      dataIndex: "photo",
      render: (photo) => (
        photo ? (
          <Image
            src={`data:image/jpeg;base64,${photo}`}
            width="100px"
            height="100px"
            style={{ objectFit: "cover", borderRadius: "8px" }}
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" // Transparent 1x1 base64 as final fallback
          />
        ) : (
          <div style={{ width: 100, height: 100, backgroundColor: '#fafafa', border: '1px dashed #d9d9d9', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bfbfbf', margin: '0 auto', borderRadius: 8, fontSize: 12 }}>
            Sin foto
          </div>
        )
      ),
    },
    {
      title: "Motivo del rechazo",
      dataIndex: "comment_response",
      align: "center",
    },
    {
      title: "Estado",
      dataIndex: "state",
      render: (state, record) => {
        let color = "default";
        if (state === 3) color = "error";
        if (state === 2) color = "success";
        if (state === 1) color = "warning";
        return (
          <Tag color={color} style={{ fontWeight: 600 }}>
            {record.stateName}
          </Tag>
        );
      },
    },
  ];
  useEffect(() => {
    const style = document.createElement("style");
    const currentRef = viewRef.current;
    style.innerHTML = `
          .ant-image-preview-img-wrapper {
            display: flex;
            justify-content: center;
            align-items:center;
          }
        `;
    if (currentRef) {
      currentRef.appendChild(style);
    }

    return () => {
      if (currentRef) {
        currentRef.removeChild(style);
      }
    };
  }, []);
  console.log(pausesHistory)

  return (
    <div ref={viewRef}>
      <HeaderList
        title="HISTORIAL DE SOLICITUDES"
        back={-1}
        actions={
          <div className={styles.actions}>
           
            <DatePicker.RangePicker
              value={dates}
              onChange={onChangeDates}
            />
             <Button type="primary" onClick={exportToCSV}>
              Exportar
            </Button>
          </div>
        }
      />

      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <Table dataSource={pausesHistory} columns={columns} />
      )}
    </div>
  );
};

export default DriversPauseHistoryUI;
